export default __webpack_public_path__ + "static/media/uncheck.8446bc63.svg";